export default "/static/dashboard/build/app/img/v2/b49bc9fb79a13709345a605b51b53f22.png";